import React from 'react';
import { IconProps } from './types';

const RefreshIcon: React.FC<IconProps> = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_493_25778" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_493_25778)">
        <path
          d="M10.0416 16.6663C8.18054 16.6663 6.5972 16.0205 5.29165 14.7288C3.98609 13.4372 3.33331 11.8608 3.33331 9.99967V9.85384L1.99998 11.1872L0.833313 10.0205L4.16665 6.68717L7.49998 10.0205L6.33331 11.1872L4.99998 9.85384V9.99967C4.99998 11.3886 5.48956 12.5691 6.46873 13.5413C7.4479 14.5136 8.63887 14.9997 10.0416 14.9997C10.4028 14.9997 10.7569 14.958 11.1041 14.8747C11.4514 14.7913 11.7916 14.6663 12.125 14.4997L13.375 15.7497C12.8472 16.0552 12.3055 16.2844 11.75 16.4372C11.1944 16.59 10.625 16.6663 10.0416 16.6663ZM15.8333 13.3122L12.5 9.97884L13.6666 8.81217L15 10.1455V9.99967C15 8.61079 14.5104 7.43023 13.5312 6.45801C12.5521 5.48579 11.3611 4.99967 9.95831 4.99967C9.5972 4.99967 9.24304 5.04134 8.89581 5.12467C8.54859 5.20801 8.20831 5.33301 7.87498 5.49967L6.62498 4.24967C7.15276 3.94412 7.69443 3.71495 8.24998 3.56217C8.80554 3.4094 9.37498 3.33301 9.95831 3.33301C11.8194 3.33301 13.4028 3.97884 14.7083 5.27051C16.0139 6.56217 16.6666 8.13856 16.6666 9.99967V10.1455L18 8.81217L19.1666 9.97884L15.8333 13.3122Z"
          fill="#0276FE"
        />
      </g>
    </svg>
  );
};
export default RefreshIcon;
